import React from "react";
import { NotificationInterface } from "../../../../store/mine_craft/notificationsSlice";
import Card from "../../../../componets/Card";

const _Details = ({ notification }: { notification: NotificationInterface | undefined }) => {
  if (!notification) {
    return null;
  }

  return (
    <>
      <Card className='v-mb-20'>
      </Card>
    </>
  );
}

export default _Details;
